import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button/custom-theme-button';
import * as Styled from './styled';
import { overviewMessages, dropDownListMessages } from '../../messages';
var COLLAPSED_LIST_SITE_COUNT = 3;
export var DropdownList = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownList, _React$Component);
  var _super = _createSuper(DropdownList);
  function DropdownList() {
    var _this;
    _classCallCheck(this, DropdownList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isExpanded: false
    });
    _defineProperty(_assertThisInitialized(_this), "showDropdownList", function () {
      _this.setState({
        isExpanded: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "hideDropdownList", function () {
      _this.setState({
        isExpanded: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getVisibleSites", function () {
      return _this.state.isExpanded ? _this.props.accessibleSites : _this.props.accessibleSites.slice(0, COLLAPSED_LIST_SITE_COUNT);
    });
    return _this;
  }
  _createClass(DropdownList, [{
    key: "render",
    value: function render() {
      var accessibleSites = this.props.accessibleSites;
      var isExpanded = this.state.isExpanded;
      var visibleSites = this.getVisibleSites();
      var footNote = visibleSites.length === accessibleSites.length && /*#__PURE__*/React.createElement(Styled.AccessibleSitesListFootnote, null, /*#__PURE__*/React.createElement(FormattedMessage, overviewMessages.paragraphLoseAccessFootnote));
      var toggleExpand = accessibleSites.length > COLLAPSED_LIST_SITE_COUNT && /*#__PURE__*/React.createElement(Styled.ButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
        onClick: isExpanded ? this.hideDropdownList : this.showDropdownList,
        appearance: "link",
        spacing: "none"
      }, isExpanded ? /*#__PURE__*/React.createElement(FormattedMessage, dropDownListMessages.collapseButton) : /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, dropDownListMessages.expandButton, {
        values: {
          num: accessibleSites.length - 3
        }
      }))));
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.AccessibleSitesList, null, visibleSites.map(function (url, idx) {
        return /*#__PURE__*/React.createElement("li", {
          key: idx
        }, url);
      })), footNote, toggleExpand);
    }
  }]);
  return DropdownList;
}(React.Component);
export default DropdownList;